import React from "react";
import { getFlagUrl } from "./Utils/getFlagUrl";

const EnduranceQualificationMobile = ({ data, rowRange, boldRows, discipline }) => {
  const isSpacer = (row) => row.every((cell) => !cell || cell.trim() === "");

  const isHeaderRow = (row) => {
    const headers = row.map(cell => cell?.toLowerCase().trim());
    return headers.includes("rnk") && headers.includes("last name");
  };

  let headerRowIndex = -1;
  let filteredData = [];

  for (let i = 0; i < data.length; i++) {
    const row = data[i];
    if (isHeaderRow(row)) {
      headerRowIndex = i;
      continue; // přeskočíme samotný header
    }
    if (!isSpacer(row)) {
      filteredData.push(row);
    }
  }

  const renderRiderRow = (row, index) => {
    const rowNumber = rowRange[0] + index + 1;
    const isBold = boldRows.includes(rowNumber);
    const rank = row[0] || "";
    const lastName = row[2] || "";
    const firstName = row[3] || "";
    const country = row[4] || "";
    const points = row[5] || "";

    const disciplineName = discipline?.toLowerCase() || "";
    const hasPoints =
      disciplineName.includes("points race") ||
      (disciplineName.includes("omnium") && disciplineName.includes("qualifying"));

    return (
        <div key={index} className={`sqm-row ${isBold ? "bold-row" : ""}`}>
        <div className="sqm-rank">{rank}</div>
      
        <div className="sqm-left">
          <div className="sqm-last-name">{lastName}</div>
          <div className="sqm-first-name">{firstName}</div>
        </div>
      
        <div className="sqm-right eqm-right">
  <div className="eqm-col eqm-flags">
    <img src={getFlagUrl(country)} alt={country} className="flag-icon" />
  </div>
  <div className="eqm-col eqm-points">
    {hasPoints ? points : ""}
  </div>
  <div className="eqm-col eqm-q">
    {row[row.length - 1] === "Q" && <span className="eqm-q-badge">Q</span>}
  </div>
</div>

      </div>
      



     
    );
  };

  return (
    <div className="mobile-sprint-qualification">
      {filteredData.map((row, index) => renderRiderRow(row, index))}
    </div>
  );
};

export default EnduranceQualificationMobile;
